export const pcPageConfig = {
  "title": "Realtime Sales",
  "titleCN": "实时销售",
  "path": "/realtime/baseSales",
  "defaultTab": "overview",
  "titleIcon": "",
  "timeZone": "",
  "tabList": [
    {
      "id": "overview",
      "tabName": "Overview",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "refresh": true,
      "refreshConfig": {
        "contentEn": "Click to refresh or auto refresh every 30 Mins.",
        "contentCn": "单击可刷新或每30分钟自动刷新一次."
      },
      "notificationPath": "/realtime/baseSales/overview",
      "path": "/realtime/baseSales/overview",
      "tabIcon": "",
      "logConfig": {
        "pageId": "206201",
        "pageName": "realtimeSalesOverview",
        "extInfo": "realtimeSalesOverview",
        "pagePath": "/realtime/baseSales/overview"
      },
      "filters": [
        {
          "name": "realtimeSalesFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/baseSales/overview",
          "componentList": [
            {
              "name": "SteamSalesService",
              "className": "",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/realtime/sales",
                  "dataKey": "baseSales",
                  "refreshKey": "realtime_sales",
                  "interval": 1800000
                }
              },
              "children": [
                {
                  "name": "SteamSalesService",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/realtime/acc_sales_units_revenue",
                      "dataKey": "accSalesUnitsRevenue",
                      "refreshKey": "realtime_sales",
                      "interval": 1800000
                    }
                  },
                  children: [
                    {
                      "name": "SteamSalesService",
                      "className": "",
                      "type": "view",
                      "style": {},
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/pc/realtime/lifetime/sales/trend",
                          "dataKey": "accSalesUnitsRevenueTrend",
                          "refreshKey": "realtime_sales",
                          "interval": 1800000
                        }
                      },
                      "children": [
                        {
                          "name": "SteamSalesService",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/event_analysis/realtime/date_event_list",
                              "isDark": true,
                              "dataKey": "date_event_list",
                              "refreshKey": "realtime_user_event",
                              "interval": 1800000,
                              "eventInterval": 30
                            }
                          },
                          "children": [
                            {
                              "name": "MetricsCardTitle",
                              "className": "",
                              "type": "view",
                              "style": {},
                              "props": {
                                "config": {
                                  "titleEn": "Realtime Key Metrics",
                                  "titleCn": "实时关键指标",
                                  "isMetricsExplain": true,
                                  "metricsWidth": 80,
                                  "data": [
                                    {
                                      "titleEn": "Est. Gross Base Game Units",
                                      "titleCn": "预估本体销量",
                                      "explainEn": "The estimated total daily base game sales of the game across all platforms.",
                                      "explainCn": "游戏当天的各平台预估的本体总销量"
                                    },
                                    {
                                      "titleEn": "Est. Gross Revenue",
                                      "titleCn": "预估收入",
                                      "explainEn": "The estimated total revenue from all products(full game, DLC, bundles, microtransactions, etc.) across all platforms on the day.",
                                      "explainCn": "游戏当天所有产品（完整游戏、dlc、bundle、mtx...）在各平台收入的预估总和。"
                                    },
                                    {
                                      "titleEn": "Est. Lifetime Gross  Base Game Units",
                                      "titleCn": "预估累计本体销量",
                                      "explainEn": "The estimated cumulative number of base game units sold across all platforms, based on sales reports from the game's release date to the selected end date.",
                                      "explainCn": "从游戏发布到所选结束日期，预估的各平台销售报告累计售出的游戏本体数。"
                                    },
                                    {
                                      "titleEn": "Est. Lifetime Gross Revenue",
                                      "titleCn": "预估累计收入",
                                      "explainEn": "The estimated cumulative total game revenue across all platforms, based on sales reports from the game's release date to the selected end date.",
                                      "explainCn": "从游戏发布到所选结束日期，预估的各平台销售报告累计游戏收入。"
                                    },
                                  ]
                                }
                              }
                            },
                            {
                              "name": "CardContext",
                              "children": [
                                {
                                  "name": "CommonRow",
                                  "className": "",
                                  "type": "layout",
                                  "style": {
                                    "marginBottom": "10px"
                                  },
                                  "props": {},
                                  "children": [
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {},
                                      "props": {
                                        "w": 6
                                      },
                                      "children": [
                                        {
                                          "name": "SteamSalesCard",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "dataKey": [
                                              "gross_full_game_units_card"
                                            ],
                                            "apiDataKey": [
                                              "baseSales"
                                            ],
                                            "config": {
                                              "titleIcon": "",
                                              "titleEn": "Est. Gross Base Game Units",
                                              "titleCn": "预估本体销量",
                                              "formatRule": "thousandsInit",
                                              "dodData": [
                                                {
                                                  "titleEn": "DOD",
                                                  "titleCn": "日环比",
                                                  "formatRule": "absPercent1Decimal",
                                                  "extendFormatRule": "thousandsInit"
                                                },
                                                {
                                                  "titleEn": "SDLW",
                                                  "titleCn": "上周同期",
                                                  "formatRule": "absPercent1Decimal",
                                                  "extendFormatRule": "thousandsInit"
                                                }
                                              ],
                                              "rainbowKey": "Pc Est. Gross Base Game Units"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "",
                                      "type": "layout",
                                      "style": {},
                                      "props": {
                                        "w": 6
                                      },
                                      "children": [
                                        {
                                          "name": "SteamSalesCard",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "dataKey": [
                                              "gross_revenue_card"
                                            ],
                                            "apiDataKey": [
                                              "baseSales"
                                            ],
                                            "config": {
                                              "titleIcon": "",
                                              "titleEn": "Est. Gross Revenue",
                                              "titleCn": "预估收入",
                                              "formatRule": "thousands2Decimal",
                                              "preUnit": "$",
                                              "dodData": [
                                                {
                                                  "titleEn": "DOD",
                                                  "titleCn": "日环比",
                                                  "formatRule": "absPercent1Decimal",
                                                  "extendFormatRule": "thousands2Decimal"
                                                },
                                                {
                                                  "titleEn": "SDLW",
                                                  "titleCn": "上周同期",
                                                  "formatRule": "absPercent1Decimal",
                                                  "extendFormatRule": "thousands2Decimal"
                                                }
                                              ],
                                              "rainbowKey": "Pc Est. Gross Revenue"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "dbd-realtime-card-hide-dod",
                                      "type": "layout",
                                      "style": {},
                                      "props": {
                                        "w": 6
                                      },
                                      "children": [
                                        {
                                          "name": "SteamSalesCard",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "dataKey": [
                                              "lifetime_gross_full_game_units"
                                            ],
                                            "apiDataKey": [
                                              "accSalesUnitsRevenue"
                                            ],
                                            "config": {
                                              "titleIcon": "",
                                              "titleEn": "Est. Lifetime Gross Base Game Units",
                                              "titleCn": "预估累计本体销量",
                                              "formatRule": "thousandsInit",
                                              "dateFormat": "YYYY-MM-DD HH:mm",
                                              "dodData": [
                                                {
                                                  "titleEn": "DOD",
                                                  "titleCn": "日环比",
                                                  "formatRule": "absPercent1Decimal",
                                                  "extendFormatRule": "thousandsInit"
                                                },
                                                {
                                                  "titleEn": "SDLW",
                                                  "titleCn": "上周同期",
                                                  "formatRule": "absPercent1Decimal",
                                                  "extendFormatRule": "thousandsInit"
                                                }
                                              ],
                                              "rainbowKey": "Pc Est. Lifetime Gross Base Game Units"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                    {
                                      "name": "CommonCol",
                                      "className": "dbd-realtime-card-hide-dod",
                                      "type": "layout",
                                      "style": {},
                                      "props": {
                                        "w": 6
                                      },
                                      "children": [
                                        {
                                          "name": "SteamSalesCard",
                                          "className": "",
                                          "type": "view",
                                          "style": {},
                                          "props": {
                                            "dataKey": [
                                              "lifetime_gross_revenue"
                                            ],
                                            "apiDataKey": [
                                              "accSalesUnitsRevenue"
                                            ],
                                            "config": {
                                              "titleIcon": "",
                                              "titleEn": "Est. Lifetime Gross Revenue",
                                              "titleCn": "预估累计收入",
                                              "formatRule": "thousands2Decimal",
                                              "dateFormat": "YYYY-MM-DD HH:mm",
                                              "preUnit": "$",
                                              "dodData": [
                                                {
                                                  "titleEn": "DOD",
                                                  "titleCn": "日环比",
                                                  "formatRule": "absPercent1Decimal",
                                                  "extendFormatRule": "thousands2Decimal"
                                                },
                                                {
                                                  "titleEn": "SDLW",
                                                  "titleCn": "上周同期",
                                                  "formatRule": "absPercent1Decimal",
                                                  "extendFormatRule": "thousands2Decimal"
                                                }
                                              ],
                                              "rainbowKey": "Pc Est. Lifetime Gross Revenue"
                                            }
                                          }
                                        }
                                      ]
                                    },
                                  ]
                                },
                              ]
                            },
                            {
                              "name": "SegmentScrollCo",
                              "className": "margin-t-20",
                              "style": {},
                              "type": "view",
                              "props": {
                                "config": {
                                  "componentSegment": [
                                    {
                                      "value": "1",
                                      "enName": "Est. Daily Accum Gross Base Game Units",
                                      "cnName": "预估每日累计本体销量",
                                      "disable": false,
                                      "rainbowKey": "",
                                      "enTooltip": "",
                                      "cntooltip": ""
                                    },
                                    {
                                      "value": "2",
                                      "enName": "Est. Daily Accum Gross Revenue",
                                      "cnName": "预估每日累计收入",
                                      "disable": false,
                                      "rainbowKey": "",
                                      "enTooltip": "",
                                      "cntooltip": ""
                                    },
                                    {
                                      "value": "3",
                                      "enName": "Est. Lifetime Gross Base Game Units",
                                      "cnName": "预估历史累计本体销量",
                                      "rainbowKey": "",
                                      "disable": false,
                                      "enTooltip": "",
                                      "cntooltip": ""
                                    },
                                    {
                                      "value": "4",
                                      "enName": "Est. Lifetime Gross Revenue",
                                      "cnName": "预估历史累计收入",
                                      "rainbowKey": "",
                                      "disable": false,
                                      "enTooltip": "",
                                      "cntooltip": ""
                                    },
                                  ],
                                  "scrollMarginTop": "75px"
                                }
                              },
                              "children": [
                                {
                                  "name": "RealtimeRentationContext",
                                  "props": {
                                    "config": {
                                      "preTitleIcon": "",
                                      "title": "Est. Realtime Daily Accum Gross Base Game Units (30 Mins)",
                                      "titleCn": "预估每日实时累计本体销量 (30分钟)",
                                      "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                      "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                      "apiDataKey": "baseSales",
                                      "dataKey": "gross_full_game_units",
                                      "dataType": "",
                                      "table": {
                                        "option": [
                                          {
                                            "key": "time",
                                            "align": "left",
                                            "fixed": "left",
                                            "width": 100,
                                            "title": "Time",
                                            "titleCn": "时间",
                                            "formatTitle": "realtime_by_country_table_time",
                                            "valueKey": "time"
                                          },
                                          {
                                            "key": "line_dot",
                                            "align": "right",
                                            "fixed": "",
                                            "width": 100,
                                            "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                            "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                            "valueKey": "lineDot",
                                            "format": "#,##0",
                                            "type": "number"
                                          },
                                          {
                                            "key": "line_dot_last",
                                            "align": "right",
                                            "fixed": "",
                                            "width": 100,
                                            "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                            "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                            "valueKey": "lineDotLast",
                                            "format": "#,##0",
                                            "type": "number"
                                          },
                                          {
                                            "key": "line_dot_contrast",
                                            "align": "right",
                                            "fixed": "",
                                            "width": 100,
                                            "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                            "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                            "valueKey": "lineDotContrast",
                                            "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                            "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                            "format": "#,##0",
                                            "type": "number"
                                          }
                                        ],
                                        "sort": true,
                                        "columns": [
                                          "time"
                                        ],
                                        "defaultValue": [
                                          {
                                            "by": "time",
                                            "order": "desc"
                                          }
                                        ],
                                        "isRealTime": true,
                                        "height": 400
                                      },
                                      "subTitle": [
                                        {
                                          "title": "DoD",
                                          "titleCn": "日环比",
                                          "formatTitle": "",
                                          "valueKey": "dod",
                                          "unit": "percent",
                                          "bold": true
                                        },
                                        {
                                          "title": "SDLW",
                                          "titleCn": "上周同期",
                                          "formatTitle": "",
                                          "valueKey": "sdlw",
                                          "unit": "percent",
                                          "bold": true
                                        }
                                      ],
                                      "event": {
                                        "show": true,
                                        "link": "eventAnalysis/eventDetails",
                                        "dataKey": "date_event_list",
                                        "valueKey": "event",
                                        "timeType": "Hour",
                                        "cssStyle": {
                                          "top": "82%"
                                        }
                                      },
                                      "chart": {
                                        "type": "line",
                                        "series": [
                                          {
                                            "valueKey": "line_dot",
                                            "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                            "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                          },
                                          {
                                            "valueKey": "line_dot_last",
                                            "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                            "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                          },
                                          {
                                            "valueKey": "line_dot_contrast",
                                            "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                            "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                            "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                            "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                          }
                                        ],
                                        "tooltip": {
                                          "title": "Est. Daily Accum Gross Base Game Units",
                                          "titleCn": "预估每日累计本体销量"
                                        }
                                      }
                                    }
                                  },
                                  "id": 1
                                },
                                {
                                  "name": "RealtimeRentationContext",
                                  "props": {
                                    "config": {
                                      "preTitleIcon": "",
                                      "title": "Est. Realtime Daily Accum Gross Revenue (30 Mins)",
                                      "titleCn": "预估每日实时累计收入 (30分钟)",
                                      "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                      "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                      "apiDataKey": "baseSales",
                                      "dataKey": "gross_revenue",
                                      "dataType": "money",
                                      "currencyUnit": "$",
                                      "table": {
                                        "option": [
                                          {
                                            "key": "time",
                                            "align": "left",
                                            "fixed": "left",
                                            "width": 100,
                                            "title": "Time",
                                            "titleCn": "时间",
                                            "formatTitle": "realtime_by_country_table_time",
                                            "valueKey": "time"
                                          },
                                          {
                                            "key": "line_dot",
                                            "align": "right",
                                            "fixed": "",
                                            "width": 100,
                                            "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                            "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                            "valueKey": "lineDot",
                                            "format": "#,##0.00",
                                            "type": "number"
                                          },
                                          {
                                            "key": "line_dot_last",
                                            "align": "right",
                                            "fixed": "",
                                            "width": 100,
                                            "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                            "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                            "valueKey": "lineDotLast",
                                            "format": "#,##0.00",
                                            "type": "number"
                                          },
                                          {
                                            "key": "line_dot_contrast",
                                            "align": "right",
                                            "fixed": "",
                                            "width": 100,
                                            "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} Contrast Day",
                                            "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} 对比日",
                                            "valueKey": "lineDotContrast",
                                            "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                            "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}",
                                            "format": "#,##0.00",
                                            "type": "number"
                                          }
                                        ],
                                        "sort": true,
                                        "columns": [
                                          "time"
                                        ],
                                        "defaultValue": [
                                          {
                                            "by": "time",
                                            "order": "desc"
                                          }
                                        ],
                                        "isRealTime": true,
                                        "height": 400
                                      },
                                      "subTitle": [
                                        {
                                          "title": "DoD",
                                          "titleCn": "日环比",
                                          "formatTitle": "",
                                          "valueKey": "dod",
                                          "unit": "percent",
                                          "bold": true
                                        },
                                        {
                                          "title": "SDLW",
                                          "titleCn": "上周同期",
                                          "formatTitle": "",
                                          "valueKey": "sdlw",
                                          "unit": "percent",
                                          "bold": true
                                        }
                                      ],
                                      "event": {
                                        "show": true,
                                        "link": "eventAnalysis/eventDetails",
                                        "dataKey": "date_event_list",
                                        "valueKey": "event",
                                        "timeType": "Hour",
                                        "cssStyle": {
                                          "top": "82%"
                                        }
                                      },
                                      "chart": {
                                        "type": "line",
                                        "series": [
                                          {
                                            "valueKey": "line_dot",
                                            "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                            "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                          },
                                          {
                                            "valueKey": "line_dot_last",
                                            "title": "Yesterday {{singleDaily|date|YYYY-MM-DD|-1|day}}",
                                            "titleCn": "昨天 {{singleDaily|date|YYYY-MM-DD|-1|day}}"
                                          },
                                          {
                                            "valueKey": "line_dot_contrast",
                                            "title": "Same Day Last Week {{contrastDaily|date|YYYY-MM-DD}} (Contrast Day)",
                                            "titleCn": "上周同期 {{contrastDaily|date|YYYY-MM-DD}} (对比日)",
                                            "changeDateTitle": "Contrast Day {{contrastDaily|date|YYYY-MM-DD}}",
                                            "changeDateTitleCn": "对比日 {{contrastDaily|date|YYYY-MM-DD}}"
                                          }
                                        ],
                                        "tooltip": {
                                          "title": "Est. Daily Accum Gross Revenue",
                                          "titleCn": "预估每日累计收入"
                                        }
                                      }
                                    }
                                  },
                                  "id": 2
                                },
                                {
                                  "name": "RealtimeRentationContext",
                                  "props": {
                                    "config": {
                                      "preTitleIcon": "",
                                      "title": "Est. Realtime Lifetime Gross Base Game Units (30 Mins)",
                                      "titleCn": "预估历史实时累计本体销量  (30分钟)",
                                      "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                      "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                      "apiDataKey": "accSalesUnitsRevenueTrend",
                                      "dataKey": "lifetime_gross_full_game_units",
                                      "dataType": "",
                                      "table": {
                                        "option": [
                                          {
                                            "key": "time",
                                            "align": "left",
                                            "fixed": "left",
                                            "width": 100,
                                            "title": "Time",
                                            "titleCn": "时间",
                                            "formatTitle": "realtime_by_country_table_time",
                                            "valueKey": "time"
                                          },
                                          {
                                            "key": "line_dot",
                                            "align": "right",
                                            "fixed": "",
                                            "width": 100,
                                            "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                            "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                            "valueKey": "lineDot",
                                            "format": "#,##0",
                                            "type": "number"
                                          },
                                        ],
                                        "sort": true,
                                        "columns": [
                                          "time"
                                        ],
                                        "defaultValue": [
                                          {
                                            "by": "time",
                                            "order": "desc"
                                          }
                                        ],
                                        "isRealTime": true,
                                        "height": 400
                                      },
                                      "event": {
                                        "show": true,
                                        "link": "eventAnalysis/eventDetails",
                                        "dataKey": "date_event_list",
                                        "valueKey": "event",
                                        "timeType": "Hour",
                                        "cssStyle": {
                                          "top": "82%"
                                        }
                                      },
                                      "chart": {
                                        "type": "line",
                                        "series": [
                                          {
                                            "valueKey": "line_dot",
                                            "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                            "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                          },
                                        ],
                                        "tooltip": {
                                          "title": "Est. Lifetime Gross Base Game Units",
                                          "titleCn": "预估历史累计本体销量"
                                        }
                                      }
                                    }
                                  },
                                  "id": 3
                                },
                                {
                                  "name": "RealtimeRentationContext",
                                  "props": {
                                    "config": {
                                      "preTitleIcon": "",
                                      "title": "Est. Realtime Lifetime Gross Revenue (30 Mins)",
                                      "titleCn": "预估历史实时累计收入 (30分钟)",
                                      "explain": "Statistical Time: {{lastUpdateTime|string}}",
                                      "explainCn": "统计时间: {{lastUpdateTime|string}}",
                                      "apiDataKey": "accSalesUnitsRevenueTrend",
                                      "dataKey": "lifetime_gross_revenue",
                                      "dataType": "money",
                                      "currencyUnit": "$",
                                      "table": {
                                        "option": [
                                          {
                                            "key": "time",
                                            "align": "left",
                                            "fixed": "left",
                                            "width": 100,
                                            "title": "Time",
                                            "titleCn": "时间",
                                            "formatTitle": "realtime_by_country_table_time",
                                            "valueKey": "time"
                                          },
                                          {
                                            "key": "line_dot",
                                            "align": "right",
                                            "fixed": "",
                                            "width": 100,
                                            "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                            "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}",
                                            "valueKey": "lineDot",
                                            "format": "#,##0.00",
                                            "type": "number"
                                          },
                                        ],
                                        "sort": true,
                                        "columns": [
                                          "time"
                                        ],
                                        "defaultValue": [
                                          {
                                            "by": "time",
                                            "order": "desc"
                                          }
                                        ],
                                        "isRealTime": true,
                                        "height": 400
                                      },
                                      "event": {
                                        "show": true,
                                        "link": "eventAnalysis/eventDetails",
                                        "dataKey": "date_event_list",
                                        "valueKey": "event",
                                        "timeType": "Hour",
                                        "cssStyle": {
                                          "top": "82%"
                                        }
                                      },
                                      "chart": {
                                        "type": "line",
                                        "series": [
                                          {
                                            "valueKey": "line_dot",
                                            "title": "Today {{singleDaily|date|YYYY-MM-DD}}",
                                            "titleCn": "今天 {{singleDaily|date|YYYY-MM-DD}}"
                                          },
                                        ],
                                        "tooltip": {
                                          "title": "Est. Lifetime Gross Revenue",
                                          "titleCn": "预估历史累计收入"
                                        }
                                      }
                                    }
                                  },
                                  "id": 4
                                },
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "byPlatform",
      "tabName": "By Platform",
      "tabNameCN": "分平台",
      "isHaveNotification": true,
      "refresh": true,
      "notificationPath": "/realtime/baseSales/byPlatform",
      "path": "/realtime/baseSales/byPlatform",
      "tabIcon": "",
      "logConfig": {
        "pageId": "206202",
        "pageName": "realtimeSalesByPlatform",
        "extInfo": "realtimeSalesByPlatform",
        "pagePath": "/realtime/baseSales/byPlatform"
      },
      "filters": [
        {
          "name": "realtimeSalesPlatformFilter",
          "isOpenSticky": false,
          "isHaveFilterSave": true,
          "filterPath": "/realtime/baseSales/byPlatform",
          "componentList": [
            {
              "name": "SteamSalesService",
              "className": "dbd-realtime-sales-trend",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/pc/realtime/dimension/sales",
                  "dataKey": "dimension_sales",
                  "refreshKey": "realtime_platform",
                  "interval": 1800000,
                  "isDimension": true
                }
              },
              "data": {
                "dataBy": "system"
              },
              children: [
                {
                  "name": "SteamSalesService",
                  "className": "dbd-realtime-sales-trend",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/realtime/dimension/lifetime/sales",
                      "dataKey": "dimension_sales_lifetime",
                      "refreshKey": "realtime_platform",
                      "interval": 1800000,
                      "isDimension": true
                    }
                  },
                  "data": {
                    "dataBy": "system"
                  },
                  "children": [
                    {
                      "name": "ScrollBodyCo",
                      "className": "margin-t-20",
                      "style": {},
                      "type": "view",
                      "props": {
                        "hasRight": false,
                        "config": {
                          "dataKey": "dataBy",
                          "componentSegment": [
                            {
                              "value": "1",
                              "enName": "Est. Daily Accum Gross Base Game Units",
                              "cnName": "预估每日累计本体销量",
                              "disable": false,
                              "rainbowKey": "",
                              "enTooltip": "",
                              "cntooltip": ""
                            },
                            {
                              "value": "2",
                              "enName": "Est. Daily Accum Gross Revenue",
                              "cnName": "预估每日累计收入",
                              "disable": false,
                              "rainbowKey": "",
                              "enTooltip": "",
                              "cntooltip": ""
                            },
                            {
                              "value": "3",
                              "enName": "Est. Lifetime Gross Base Game Units",
                              "cnName": "预估历史累计本体销量",
                              "rainbowKey": "",
                              "disable": false,
                              "enTooltip": "",
                              "cntooltip": ""
                            },
                            {
                              "value": "4",
                              "enName": "Est. Lifetime Gross Revenue",
                              "cnName": "预估历史累计收入",
                              "rainbowKey": "",
                              "disable": false,
                              "enTooltip": "",
                              "cntooltip": ""
                            },
                          ],
                          "scrollMarginTop": "75px"
                        }
                      },
                      "children": [
                        {
                          "name": "TrendChartCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "config": {
                              "preTitleIcon": "",
                              "title": "Est. Realtime Daily Accum Gross Base Game Units (30Mins)",
                              "titleCn": "预估每日实时累计本体销量 (30分钟)",
                              "dataType": "int",
                              "dataKey": "dimension_sales",
                              "showDownloadModal": false,
                              "metricsCardList": {
                                "dataKey": "gross_full_game_units_info"
                              },
                              "lastTime": {
                                "dataKey": "gross_full_game_units_last_time"
                              },
                              "chart": {
                                "dataKey": "gross_full_game_units_top",
                                "tooltip": {
                                  "title": "Est. Daily Accum Gross Base Game Units",
                                  "titleCn": "预估每日累计本体销量",
                                  "share": true,
                                  "shareTitle": "Share",
                                  "shareTitleCn": "占比"
                                }
                              },
                              "table": {
                                "dataKey": "gross_full_game_units_list",
                                "options": [
                                  {
                                    "key": "time",
                                    "align": "left",
                                    "width": 100,
                                    "title": "Time",
                                    "titleCn": "时间",
                                    "formatTitle": "realtime_by_country_table_time",
                                    "type": "date",
                                    "format": "HH:mm"
                                  },
                                  {
                                    "key": "type",
                                    "align": "left",
                                    "width": 100,
                                    "title": "table_{{dataBy}}",
                                    "titleCn": "table_{{dataBy}}",
                                    "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                    "type": "string"
                                  },
                                  {
                                    "key": "value",
                                    "align": "right",
                                    "width": 160,
                                    "title": "Est. Daily Accum Gross Base Game Units",
                                    "titleCn": "预估每日累计本体销量",
                                    "type": "number",
                                    "format": "#,##0"
                                  },
                                  {
                                    "key": "share",
                                    "align": "right",
                                    "width": 100,
                                    "title": "Share",
                                    "titleCn": "占比",
                                    "formatTitle": "",
                                    "type": "number",
                                    "format": "0.0%"
                                  }
                                ]
                              }
                            }
                          }
                        },
                        {
                          "name": "TrendChartCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "config": {
                              "preTitleIcon": "",
                              "title": "Est. Realtime Daily Accum Gross Revenue (30 Mins)",
                              "titleCn": "预估每日实时累计收入 (30分钟)",
                              "dataKey": "dimension_sales",
                              "dataType": "money",
                              "formatRule": "thousands2Decimal",
                              "showDownloadModal": false,
                              "metricsCardList": {
                                "dataKey": "gross_revenue_info"
                              },
                              "lastTime": {
                                "dataKey": "gross_revenue_last_time"
                              },
                              "chart": {
                                "dataKey": "gross_revenue_top",
                                "tooltip": {
                                  "title": "Est. Daily Accum Gross Revenue",
                                  "titleCn": "预估每日累计收入",
                                  "share": true,
                                  "shareTitle": "Share",
                                  "shareTitleCn": "占比"
                                }
                              },
                              "table": {
                                "dataKey": "gross_revenue_list",
                                "options": [
                                  {
                                    "key": "time",
                                    "align": "left",
                                    "width": 100,
                                    "title": "Time",
                                    "titleCn": "时间",
                                    "formatTitle": "realtime_by_country_table_time",
                                    "type": "date",
                                    "format": "HH:mm"
                                  },
                                  {
                                    "key": "type",
                                    "align": "left",
                                    "width": 100,
                                    "title": "table_{{dataBy}}",
                                    "titleCn": "table_{{dataBy}}",
                                    "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                    "type": "string"
                                  },
                                  {
                                    "key": "value",
                                    "align": "right",
                                    "width": 100,
                                    "title": "Est. Daily Accum Gross Revenue",
                                    "titleCn": "预估每日累计收入",
                                    "type": "number",
                                    "format": "#,##0.00"
                                  },
                                  {
                                    "key": "share",
                                    "align": "right",
                                    "width": 100,
                                    "title": "Share",
                                    "titleCn": "占比",
                                    "formatTitle": "",
                                    "type": "number",
                                    "format": "0.0%"
                                  }
                                ]
                              }
                            }
                          }
                        },
                        {
                          "name": "TrendChartCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "showDodSdlw": false,
                            "config": {
                              "preTitleIcon": "",
                              "title": "Est. Realtime Lifetime Gross Base Game Units (30 Mins)",
                              "titleCn": "预估历史实时累计本体销量 (30分钟)",
                              "dataType": "int",
                              "dataKey": "dimension_sales_lifetime",
                              "showDownloadModal": false,
                              "metricsCardList": {
                                "dataKey": "lifetime_gross_full_game_units_info"
                              },
                              "lastTime": {
                                "dataKey": "lifetime_gross_full_game_units_last_time"
                              },
                              "chart": {
                                "dataKey": "lifetime_gross_full_game_units_top",
                                "tooltip": {
                                  "title": "Est. Lifetime Gross Base Game Units",
                                  "titleCn": "预估历史累计本体销量",
                                  "share": true,
                                  "shareTitle": "Share",
                                  "shareTitleCn": "占比"
                                }
                              },
                              "table": {
                                "dataKey": "lifetime_gross_full_game_units_list",
                                "options": [
                                  {
                                    "key": "time",
                                    "align": "left",
                                    "width": 100,
                                    "title": "Time",
                                    "titleCn": "时间",
                                    "formatTitle": "realtime_by_country_table_time",
                                    "type": "date",
                                    "format": "HH:mm"
                                  },
                                  {
                                    "key": "type",
                                    "align": "left",
                                    "width": 100,
                                    "title": "table_{{dataBy}}",
                                    "titleCn": "table_{{dataBy}}",
                                    "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                    "type": "string"
                                  },
                                  {
                                    "key": "value",
                                    "align": "right",
                                    "width": 100,
                                    "title": "Est. Lifetime Gross Base Game Units",
                                    "titleCn": "预估历史累计本体销量",
                                    "type": "number",
                                    "format": "#,##0"
                                  },
                                  {
                                    "key": "share",
                                    "align": "right",
                                    "width": 100,
                                    "title": "Share",
                                    "titleCn": "占比",
                                    "formatTitle": "",
                                    "type": "number",
                                    "format": "0.0%"
                                  }
                                ]
                              }
                            }
                          }
                        },
                        {
                          "name": "TrendChartCo",
                          "className": "",
                          "type": "view",
                          "props": {
                            "showDodSdlw": false,
                            "config": {
                              "preTitleIcon": "",
                              "title": "Est. Realtime Lifetime Gross Revenue (30 Mins)",
                              "titleCn": "预估历史实时累计收入 (30分钟)",
                              "dataKey": "dimension_sales_lifetime",
                              "dataType": "money",
                              "formatRule": "thousands2Decimal",
                              "showDownloadModal": false,
                              "metricsCardList": {
                                "dataKey": "lifetime_gross_revenue_info"
                              },
                              "lastTime": {
                                "dataKey": "lifetime_gross_revenue_last_time"
                              },
                              "chart": {
                                "dataKey": "lifetime_gross_revenue_top",
                                "tooltip": {
                                  "title": "Est. Lifetime Gross Revenue",
                                  "titleCn": "预估历史累计收入",
                                  "share": true,
                                  "shareTitle": "Share",
                                  "shareTitleCn": "占比"
                                }
                              },
                              "table": {
                                "dataKey": "lifetime_gross_revenue_list",
                                "options": [
                                  {
                                    "key": "time",
                                    "align": "left",
                                    "width": 100,
                                    "title": "Time",
                                    "titleCn": "时间",
                                    "formatTitle": "realtime_by_country_table_time",
                                    "type": "date",
                                    "format": "HH:mm"
                                  },
                                  {
                                    "key": "type",
                                    "align": "left",
                                    "width": 100,
                                    "title": "table_{{dataBy}}",
                                    "titleCn": "table_{{dataBy}}",
                                    "formatTitle": "realtime_by_country_table_{{dataBy}}",
                                    "type": "string"
                                  },
                                  {
                                    "key": "value",
                                    "align": "right",
                                    "width": 100,
                                    "title": "Est. Lifetime Gross Revenue",
                                    "titleCn": "预估历史累计收入",
                                    "type": "number",
                                    "format": "#,##0.00"
                                  },
                                  {
                                    "key": "share",
                                    "align": "right",
                                    "width": 100,
                                    "title": "Share",
                                    "titleCn": "占比",
                                    "formatTitle": "",
                                    "type": "number",
                                    "format": "0.0%"
                                  }
                                ]
                              }
                            }
                          }
                        },
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};